export class ServerVersion {
    memoQ: string;
    customerPortal: string;
  
    constructor(version: config.ServerVersion) {
      this.memoQ = version.MemoQServerVersion;
      this.customerPortal = version.CustomerPortalVersion;
    }
  }